import { useEffect, useState } from 'react';

import type {
  BearerMfaAuthenticationStrategy,
  BearerMfaAuthenticationStrategyRequestOptions,
} from '@reckon-web/rest-api-client';
import { FetchClient } from '@reckon-web/rest-api-client';
import { useAuth } from '@reckon-web/auth-store';

import { Config } from '../../services/Config';

import { PortalRestAuthenticationStrategy } from './PortalRestAuthenticationStrategy';

export class PortalRestApi {
  strategy: BearerMfaAuthenticationStrategy;
  client: FetchClient<BearerMfaAuthenticationStrategyRequestOptions>;
  constructor() {
    this.strategy = PortalRestAuthenticationStrategy;
    this.client = new FetchClient<
      BearerMfaAuthenticationStrategyRequestOptions
    >(Config.APPLICATION_PORTAL_REST_API_URL, {
      headers: (forUrl, options) => {
        try {
          return {
            ...this.strategy.makeHeaders(options),
          };
        } catch (error) {
          throw Error(`[${forUrl}] ${error.message}`);
        }
      },
    });
  }
  setBearerToken(token: string) {
    this.strategy.setBearerToken(token);
  }
}

export const useFetchClient = () => {
  const { credentials, isAuthenticated } = useAuth();
  const [fetchClient, setFetchClient] = useState(new PortalRestApi());

  useEffect(() => {
    if (isAuthenticated && credentials?.accessToken) {
      const fetchCl = new PortalRestApi();
      fetchCl.setBearerToken(credentials?.accessToken);
      setFetchClient(fetchCl);
    }
  }, [credentials?.accessToken, isAuthenticated]);

  return fetchClient;
};
